


















































import Vue from 'vue'
import { mapGetters } from 'vuex'
import Person from '@/types/Person.interface'
import IListAction, { IListActionType } from '@/types/components/IListAction.interface'
import IListIcon, { IListIconType } from '@/types/components/IListIcon.interface'
import Button from '@/types/components/Button.interface'
import AddToGroupForm from '@/components/AddToGroupForm.vue'
export default Vue.extend({
    components: { AddToGroupForm },
    data() {
        return {
            closeOnClick: true,
            //  Tracks the loading state of the component
            loading: false
        }
    },
    computed: {
        ...mapGetters(['personsQueue']),
        smartGroupEnabled() {
            //  Check if subscription plan allows it
            return this.$store.getters.getEnabled('filter_group')
        },
        //  The url to the support article detailing PersonsQueue
        supportUrl() {
            return `${process.env.VUE_APP_URL_LEARN}/en/articles/5314829-saved-for-later-quickly-save-contacts-to-a-global-list`
        }
    },
    methods: {
        //  Remove all persons from the list
        clear() {
            //  Clear the list
            this.$store.commit('personsQueueClear')

            //  Published the 'cleared' event
            this.$emit('cleared')
        },
        //  Delete multiple contacts
        deleteContacts() {
            //  Get the selected contacts
            const persons = this.personsQueue

            //  Prevent the menu from closing when clicking the confirm dialog (so we can show a loading spinner in the PersonsQueue)
            this.closeOnClick = false

            this.$store.dispatch('dialogOpen', {
                type: 'CONFIRM',
                title: 'Delete Contacts?',
                icon: 'bi-trash-fill',
                text: `Are you sure you want to delete ${persons.length} contact(s)?`,
                callback: async (result) => {
                    //  If the user answered 'NO' do nothing
                    if (!result) return

                    //  Start the loading spinner
                    this.loading = true

                    //  Assemble selected person ids for our request payload
                    const ids = persons.map((x) => x.id)

                    //  Send the request
                    const response = await this.$store.dispatch('personsDeleteBatch', ids)

                    //  Stop the loading spinner
                    this.loading = false

                    //  Reset the 'close-on-click' prop
                    this.closeOnClick = true

                    //  If the request failed, do nothing
                    if (!response) return

                    //  Else, clear the PersonsQueue
                    this.clear()

                    //  Notify the user of success
                    this.$store.commit('appNotificationBarSet', {
                        message: `${persons.length} Contact(s) Deleted`
                    })
                }
            })
        },
        personAction(person): IListAction {
            //  Construct our button
            const button: Button = {
                icon: 'mdi-close',
                tooltip: 'Remove from list',
                callback: () => this.removePerson(person)
            }

            //  Construct our action
            const action: IListAction = {
                type: IListActionType.button,
                button: button
            }

            //  Return our action
            return action
        },
        popSavedContactsHelp() {
            this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                title: 'Saved Selections',
                icon: 'mdi-account-multiple-check',
                text: `'Saved Selections' is a place where you can assemble a list of contacts. Search, filter, select...you can save selections from any list! <br><a class="text-center" target="_blank" href="${this.supportUrl}">Learn More</a>`
            })
        },
        //  Remove a single person from the list
        removePerson(person) {
            this.$store.commit('personsQueueRemove', person)
        },
        //  Add all persons in the list to a new static group
        saveAsGroup() {
            //  Prevent the menu from closing when clicking the AddToGroupForm
            this.closeOnClick = false

            //  If the tenant does not have feature enabled, pop dialog
            // if (!this.smartGroupEnabled) {
            //     return this.$store.dispatch('dialogOpen', {
            //         type: 'FEATURE',
            //         paywall_type: 'access',
            //         metadata: 'filter_group_enabled'
            //     })
            // }

            //  Prompt user for group name
            this.$store.dispatch('dialogOpen', {
                type: 'APP',
                component: 'add-to-group-form',
                props: {
                    persons: this.personsQueue,
                    title: 'Save as Group'
                },
                class: 'pa-4',
                events: {
                    submitted: () => {
                        //  Close the dialog
                        this.$store.dispatch('dialogClose', 'APP')

                        //  Reset the 'closeOnClick' prop
                        this.closeOnClick = true

                        //  Clear the personsQueue
                        this.clear()
                    }
                }
            })
        },
        //  The IListIcon bound to the persons list
        personIcon(person: Person): IListIcon {
            //  Get our icon from the vue filter
            const icon = this.$options.filters.personIcon(person)

            //  Create our IListIcon object
            const listIcon: IListIcon = {
                type: IListIconType.icon,
                content: icon,
                color: 'primary'
            }

            //  Return our IListIcon object
            return listIcon
        },
        //  The iList persons tile
        tile() {
            return {
                leftFooter: 'Saved',
                leftIcon: (person: Person) => this.personIcon(person),
                line1: (person: Person) =>
                    this.$options.filters.personFullNameOrEmail(person),
                line2: (person: Person) =>
                    this.$options.filters.personDefaultPhone(person) || 'no phone',
                actionContent: (person: Person) => this.personAction(person)
            }
        }
    }
})
